import React from "react";
import { Link } from "react-router-dom";

const Button = ({ text, link, className, ...rest }) => {
	return link ? (
		<Link to={link} {...rest} className={`btn btn-base ${className}`}>
			{text}
		</Link>
	) : (
		<button className={`btn btn-base ${className}`} {...rest}>
			{text}
		</button>
	);
};

export default Button;
